export interface SendingStartedActionType {
  type: '@formCreator/EVENT_SEQ_SENDING_STARTED';
}

export const sendingStarted = (): SendingStartedActionType => ({
  type: '@formCreator/EVENT_SEQ_SENDING_STARTED',
});
